import { actionPrefixer } from 'shared/utils/utils';

const prefix = actionPrefixer('ENCLAVE');

export const FETCH_ENCLAVES = prefix('FETCH_ENCLAVES');
export const FETCH_ENCLAVE_METADATA = prefix('FETCH_ENCLAVE_METADATA');
export const ENRICH_ENCLAVES_WITH_METADATA = prefix('ENRICH_ENCLAVES_WITH_METADATA');
